<div class="scanner-page">
  <div class="top-bar">
    <button type="button" class="btn btn-secondary back-btn" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      {{ 'COMMON.BACK' | translate }}
    </button>

    <div class="mode-toggle" role="group" [attr.aria-label]="'ATTENDANCE.MODE' | translate">
      <button
        type="button"
        class="mode-btn"
        [class.active]="scanMode === 'check_in'"
        (click)="setMode('check_in')"
      >
        {{ 'ATTENDANCE.ACTION_CHECK_IN' | translate }}
      </button>
      <button
        type="button"
        class="mode-btn"
        [class.active]="scanMode === 'check_out'"
        (click)="setMode('check_out')"
      >
        {{ 'ATTENDANCE.ACTION_CHECK_OUT' | translate }}
      </button>
    </div>
  </div>

  <div class="scanner-stage-wrap">
    <div #scannerStage class="scanner-stage" [class.is-scanning]="cameraActive">
      <div [id]="scannerElementId" class="scanner-host" [class.hidden-host]="!cameraActive"></div>

      <div
        class="viewfinder"
        *ngIf="cameraActive"
        [ngStyle]="viewfinderStyle"
        aria-hidden="true"
      >
        <span class="corner corner-tl"></span>
        <span class="corner corner-tr"></span>
        <span class="corner corner-bl"></span>
        <span class="corner corner-br"></span>
        <span class="scan-line"></span>
      </div>

      <div class="scanner-overlay" *ngIf="!cameraActive">
        <p class="scanner-error" *ngIf="cameraError">{{ cameraError | translate }}</p>
        <button
          type="button"
          class="btn btn-primary start-camera-btn"
          (click)="onStartCameraClick()"
          [disabled]="!!cameraError && cameraError === 'ATTENDANCE.HTTPS_REQUIRED'"
        >
          <mat-icon>photo_camera</mat-icon>
          {{ 'ATTENDANCE.START_CAMERA' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div
    class="scan-feedback"
    *ngIf="feedback; else feedbackPlaceholder"
    [attr.data-kind]="feedback.kind"
  >
    <div class="feedback-main">
      <strong class="feedback-title">{{ feedback.titleKey | translate }}</strong>
      <span class="feedback-name" *ngIf="feedback.studentName">{{ feedback.studentName }}</span>
      <span class="feedback-meta" *ngIf="feedback.className || feedback.scanTime">
        <ng-container *ngIf="feedback.className">{{ feedback.className }}</ng-container>
        <ng-container *ngIf="feedback.className && feedback.scanTime"> · </ng-container>
        <ng-container *ngIf="feedback.scanTime">{{ feedback.scanTime }}</ng-container>
      </span>
      <span class="feedback-meta" *ngIf="feedback.message">{{ feedback.message }}</span>
    </div>
    <span class="feedback-status" *ngIf="feedback.status && feedback.kind !== 'error'">
      {{ statusKey(feedback.status) | translate }}
    </span>
  </div>
</div>

<ng-template #feedbackPlaceholder>
  <div class="scan-feedback placeholder" aria-hidden="true"></div>
</ng-template>
